import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NotificationService } from '../shared/services/notification.sevice';
import { AuthenticationService } from '../shared/_generated/backend';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent {
    @ViewChild('captcha') captcha: any;
    siteKey = environment.RECAPTCHA_SITE_KEY;
    recaptchaToken = '';

    loginForm = this.fb.nonNullable.group({
        email: ['', [Validators.required, Validators.email]]
    });

    constructor(
        private fb: FormBuilder,
        private authService: AuthenticationService,
        private router: Router,
        private notificationService: NotificationService
    ) { }

    setRecaptchaToken(token: string | null) {
        this.recaptchaToken = token ?? '';
    }

    async login() {
        try {
            this.validateForm();
            const { email } = this.loginForm.getRawValue();
            await firstValueFrom(this.authService.loginWithMagicLink(this.recaptchaToken, { emailAddress: email }));
            this.router.navigateByUrl('/email-sent');
        } catch (error) {
            if (error instanceof HttpErrorResponse) {
                if (error.status === 400) {
                    const errorMessage = error.error.message || error.message;
                    this.notificationService.showErrorSnackBar(errorMessage);
                } else {
                    console.error(error);
                    this.notificationService.showErrorSnackBar('Kiszolgáló hiba.');
                }
            } else {
                console.error(error);
                this.notificationService.showErrorSnackBar('Váratlan hiba.');
            }
        }
    }

    validateForm() {
        if (this.loginForm.invalid) {
            throw new Error('Invalid form field!');
        }
    }

}
